import classNames from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from '../Swiper';
import Flex from '../Flex';

import './styles.css';
import { envConfig } from '@/configs';

export interface PriceSwiperProps {
  values: (string | number)[];
  selected?: string;
  onSelect?: (key: string) => void;
}

export function PriceSwiper({
  values,
  selected,
  onSelect
}: PriceSwiperProps) {

  const [t] = useTranslation(['common']);
  const handleClick = useCallback((key: string) => {
    if (onSelect) onSelect(String(key));
  }, [onSelect]);

  return (
    <Flex className="swiper-price-container">
      <Swiper
        spaceBetween={5}
        slidesPerView={3}
      >
        {values.map(val => {
          return (
            <SwiperSlide
              key={String(val)}
            >
              <Flex
                onClick={handleClick.bind({}, val as any)}
                justify="center" gap={4} className={classNames('slide-inner', { 'swiper-slide-selected': String(val) === selected })}>
                {val !== 'custom' ? (
                  <>
                    <span>{val}</span>
                    {envConfig.ui.removeCurrency ? <></> : <span>{t('common:labels.tomans')}</span>}
                  </>
                ) : <span>{t('common:labels.custom-amount')}</span>
                }
              </Flex>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Flex>
  );
}

export default PriceSwiper;
